import {call, put, select, takeLatest} from "redux-saga/effects";
import {
  getLocations,
  getSites,
  postClaimController,
  postUnClaimController,
  getSiteForFavControllerAsync,
  getLocationForFavControllerAsync,
} from "../AsyncActions/sites.async";
import {getCurrentCustomer} from "../Selectors/customers.selectors";
import * as actions from "../action.constants";
import {
  getCurrentSite,
  getSelectedLocations,
  getSiteList,
} from "../Selectors/sites.selectors";
import {getSelectedController} from "../Selectors/controllers.selectors";
import {controllersRequest} from "../Sagas/controllers.saga";
import {inventoriesRequest} from "./inventories.saga";

function* sitesRequest(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const response = yield call(getSites, {
      customerId: currentCustomer?.id,
      type: "get",
      pageUrl,
    });
    if (response?.data) {
      let payload = response.data;
      if (pageUrl) {
        const previousResults = yield select(getSiteList);
        payload = {
          ...response.data,
          results: [...(previousResults || []), ...(response.data.results || [])],
        };
      }
      yield put({type: actions.STORE_SITES, payload});
    }
  } catch (e) {
    /* empty */
  }
}

function* getSiteAndLocationForFavController(action = {}) {
  const {siteId, locationId} = action;
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const response1 = yield call(
      getSiteForFavControllerAsync,
      currentCustomer?.id,
      siteId
    );

    if (response1) {
      yield put({type: actions.STORE_SELECTED_SITE, selectedSite: response1?.data});
    }
    const response2 = yield call(
      getLocationForFavControllerAsync,
      currentCustomer?.id,
      siteId,
      locationId
    );
    if (response2) {
      yield put({type: actions.STORE_SELECTED_LOCATION, payload: response2?.data});
    }
  } catch (e) {
    /* empty */
  }
}

function* locationsRequest() {
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const currentSite = yield select(getCurrentSite);
    const response = yield call(getLocations, {
      customerId: currentCustomer?.id,
      siteId: currentSite?.id,
      method: "get",
    });
    if (response?.data) {
      yield put({type: actions.STORE_LOCATIONS, payload: response.data.results || []});
    }
  } catch (e) {
    /* empty */
  }
}

function* claimController(action = {}) {
  const {reqPayload, callback = () => {}} = action;
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const currentSite = yield select(getCurrentSite);
    const currentLocation = reqPayload?.location;
    delete reqPayload.location;
    yield call(
      postClaimController,
      {
        customerId: currentCustomer?.id,
        siteId: currentSite?.id,
        locationId: currentLocation,
      },
      reqPayload
    );
    if (callback) {
      yield call(inventoriesRequest);
      yield call(controllersRequest, {pageUrl: ""});
      callback();
    }
  } catch (e) {
    /* empty */
  }
}

function* sendSiteModalData(action = {}) {
  const {payload = {}, method = "", callback = () => {}} = action;
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const response = yield call(
      getSites,
      {customerId: currentCustomer?.id, type: method},
      payload
    );
    if (response) {
      yield call(sitesRequest);

      if (method === "patch") {
        const response = yield call(
          getSiteForFavControllerAsync,
          currentCustomer?.id,
          payload?.id
        );
        if (response) {
          yield put({type: actions.STORE_SELECTED_SITE, selectedSite: response?.data});
        }
      }

      if (method === "delete") {
        yield put({type: actions.STORE_SELECTED_SITE, selectedSite: {}});
      }
    }
    if (callback) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* sendLocationModalData(action) {
  const {payload = {}, method = "", callback} = action;
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const currentSite = yield select(getCurrentSite);
    const response = yield call(
      getLocations,
      {
        customerId: currentCustomer?.id,
        siteId: currentSite?.id,
        method,
      },
      payload
    );
    if (response) {
      yield call(locationsRequest);
      if (callback) yield callback(payload);
    }
  } catch (e) {
    return e;
  }
}

function* unclaimController(action = {}) {
  const {callback = () => {}} = action;
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const currentSite = yield select(getCurrentSite);
    const currentLocation = yield select(getSelectedLocations);
    const selectedController = yield select(getSelectedController);
    const response = yield call(
      postUnClaimController,
      {
        customerId: currentCustomer?.id,
        siteId: currentSite?.id,
        locationId: currentLocation?.id,
      },
      {mac: selectedController?.mac}
    );
    if (response) {
      if (callback) {
        callback();
      }
    }
  } catch (e) {
    //e
  }
}

export function* sitesSaga() {
  yield takeLatest(actions.GET_SITES, sitesRequest);
  yield takeLatest(actions.REQUEST_LOCATIONS, locationsRequest);
  yield takeLatest(actions.CLAIM_CONTROLLER, claimController);
  yield takeLatest(actions.SEND_SITE_MODAL_DATA, sendSiteModalData);
  yield takeLatest(actions.SEND_LOCATION_MODAL_DATA, sendLocationModalData);
  yield takeLatest(actions.UNCLAIM_CONTROLLER, unclaimController);
  yield takeLatest(
    actions.GET_SITE_AND_LOCATION_FOR_FAVOURITE_CONTROLLER,
    getSiteAndLocationForFavController
  );
}
